import { apiGet } from './client';

export interface Ticket {
  id: string;
  ticketNumber: string;
  qrCode: string;
  status: 'valid' | 'used' | 'cancelled';
  ticketType: string;
  price: number;
  seatInfo?: string;
  purchasedAt: string;
  usedAt?: string;
  event: {
    id: string;
    title: string;
    date: string;
    time: string;
    venue: string;
    image: string;
    category: string;
    status: string;
  };
  order: {
    id: string;
    orderNumber: string;
    paymentStatus: string;
    finalAmount: number;
  };
}

export interface Order {
  id: string;
  orderNumber: string;
  totalAmount: number;
  discount: number;
  finalAmount: number;
  paymentMethod: string;
  paymentStatus: string;
  billingName: string;
  billingEmail: string;
  createdAt: string;
  updatedAt: string;
  event: {
    id: string;
    title: string;
    date: string;
    time: string;
    venue: string;
    image: string;
  };
  ticketsCount: number;
  promoCode?: {
    code: string;
    discount: number;
  } | null;
}

export interface TicketsResponse {
  success: boolean;
  message: string;
  data: {
    tickets: Ticket[];
  };
}

export interface TicketResponse {
  success: boolean;
  message: string;
  data: {
    ticket: Ticket;
  };
}

export interface OrdersResponse {
  success: boolean;
  message: string;
  data: {
    orders: Order[];
  };
}

export interface OrderResponse {
  success: boolean;
  message: string;
  data: {
    order: Order;
  };
}

export const ticketsApi = {
  // Get user's tickets
  getTickets: (): Promise<TicketsResponse> => {
    return apiGet('/tickets');
  },

  // Get ticket by ID
  getTicketById: (id: string): Promise<TicketResponse> => {
    return apiGet(`/tickets/${id}`);
  },

  // Get user's orders
  getOrders: (): Promise<OrdersResponse> => {
    return apiGet('/orders');
  },

  // Get order by ID
  getOrderById: (id: string): Promise<OrderResponse> => {
    return apiGet(`/orders/${id}`);
  },
};




